export const text = {
  initialHeaderName: 'Uitgaande koppeling',
  description:
    'Standaard worden de NAWTE en tags van het contact verstuurd naar Zapier. Wil je meer data versturen? Voeg dan hier de extra velden toe.',
  goBackLink: '/-/apps/zapier',
  children: null,
  noTriggerFound: 'Geen uitgaande koppeling gevonden met de opgegeven id',
};

export const breadcrumbs = [
  {
    to: '/-/apps',
    label: 'Apps',
  },
  { to: '/-/apps/zapier', label: 'Zapier' },
];
